import http from "../http-common-2";

class NotificationService {
  getNotification(token: any, page: any, pageSize: any, category: any) {
    return http.get(
      `/fcm/notification?pageSize=${pageSize}&page=${page}&category=${category}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  createNotification(data: any) {
    return http.post(`/fcm/notification/create`, data);
  }

  sendNotification(id: any, type: string, tokens: any[]) {
    return http.post(`/fcm/send/notification/${id}`, {
      users: tokens,
      type: type,
    });
  }

  deleteNotification(id: any) {
    return http.delete(`/fcm/notification/${id}`);
  }

  getAllUsers() {
    return http.get(`/fcm/users/portal`);
  }

  createNotifcationEvent(data:any) {
    return http.post(`/scheduled/notification`,data);
  }

  getNotificationLogs() {
    return http.get(`/scheduled/notification`);
  }

  getWhatsappTemplates() {
    return http.get(`/whatsapp/notification/templates`);
  }

  getWhatsappLogs() {
    return http.get(`/scheduled/whatsapp/notification`);
  }

  getNotificationById(id:any){
    return http.get(`/fcm/notification/${id}`);
  }

  updateNotificationById(id:any,data:any){
    return http.put(`/fcm/notification/${id}`,data);
  }

  scheduleWhatsappNotification(data:any){
    return http.post(`/scheduled/whatsapp/notification`,data);
  }

}
export default new NotificationService();
